module.exports = __webpack_public_path__ + "img/patients9.8321aa63.jpg";